module.exports = __webpack_public_path__ + "img/7.b5dd2b8b.jpg";